define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/reflection",
	"dojo/store/Memory",
	"csi/heading/StringSelection",
	"./AttributeMapMixin"
], function(declare,_,reflection,Memory,StringSelection,AttributeMapMixin) {

	var BLANK = "_";

	return declare([StringSelection, AttributeMapMixin], {
		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			var type = ctx.getNode()._type;
			var value = this._getValue(ctx, h) || BLANK;

			params.value = value;
			params.query = {
				_used: {
					test: function(usedValue, item) {

						if (item.id == BLANK || item.id == value) return true;
						if (!item._type || !type || usedValue) return false;
						if (item._type == type) return true;

						var rc1 = item._type.startsWith("ref") ? reflection.getClass(item._type.split(":")[1]) : null;
						var rc2 = type.startsWith("ref") ? reflection.getClass(type.split(":")[1]) : null;

						if (!rc1 || !rc2) return false;

						if (rc1.isDerivedFrom(rc2) || rc2.isDerivedFrom(rc1)) return true;

						// replace Product with Material and Style
						// needed because CostProduct attr of CostScenario (Product) needs to match to Actual (DSLineItemReferenceable)
						if (rc1.m_type == "Product" || rc2.m_type == "Product") {
							var rcStyle = reflection.getClass("Style");
							var rcMaterial = reflection.getClass("Material");
							return rc1.m_type == "Product" ? rcStyle.isDerivedFrom(rc2) && rcMaterial.isDerivedFrom(rc2) : rcStyle.isDerivedFrom(rc1) && rcMaterial.isDerivedFrom(rc1);
						}

						return false;
					}
				}
			};

			return this.inherited(arguments);
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*InlineSelect*/editNode) {
			// summary: undo conversion of empty-string to BLANK
			var result = editNode.get("value");
			return (result === BLANK) ? "" : result;
		},

		getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
			return this._createStore(ctx.view._getMapSetupSetting());
		},

		_createStore: function(map) {
			var usedIds = this._getInitiallyUsedDestAttrIds(map);
			var items = [{id: BLANK, name: "", _used: false}];
			_.each(this._getDestAttributes(), function(destAttr) {
				var destAttrId = this._getDestAttrId(destAttr);
				items.push({
					id: destAttrId,
					name: this._getDestAttrName(destAttr),
					_type: this._getTypeForMatching(destAttr),
					_used: !!usedIds[destAttrId]
				})
			}, this);
			return new Memory({data: items});
		},

		_getInitiallyUsedDestAttrIds: function(map) {
			// summary: figure out which dest attrs have already been mapped to when the table first displays
			var usedIds = {};
			_.each(this._getSourceAttributes(), function(sourceAttr) {
				var destAttrId = map[sourceAttr.getId()];
				if (destAttrId) {
					usedIds[destAttrId] = true;
				}
			});
			return usedIds;
		},

		// can override this
		_getDestAttrName: function(destAttr) {
			// summary: return the attribute's display name for the drop-down
			return destAttr.getId();
		},

		// can override this
		_getDestAttrId: function(destAttr) {
			// summary: return the attribute's value for the drop-down
			return destAttr.getId();
		}
	});
});
